<div class="w-1/2 tw-bg-white dark:tw-bg-dark-500 rounded tw-pb-10">
  <div class="row tw-px-[10px] tw-text-center tw-text-[16px] text-dark">
    <!-- calender Header -->
    <div
      class="tw-flex tw-justify-between tw-items-center tw-w-full tw-h-16 tw-bg-primary-800 dark:tw-bg-primary-700 tw-rounded-t-xl"
    >
      <!-- previous Month -->
      <div
        class="tw-flex tw-items-center tw-text-white"
        (click)="previousMonth()"
        [class]="
          disablePreviousMonthBtn ? 'tw-opacity-60' : 'tw-cursor-pointer'
        "
      >
        <i
          class="mdi mdi-chevron-right mdi-22px tw-text-white dark:tw-text-gray-400"
        ></i>
        <span class="tw-text-lg">{{ "common.previousMonth" | translate }}</span>
      </div>

      <!-- select Month and Year -->
      <div class="tw-flex tw-items-center tw-text-white">
        <!-- month -->
        <div class="tw-px-5 tw-flex tw-items-center">
          <span
            *ngIf="!isLoading && getCalenderDataFromServer"
            class="tw-px-4 tw-text-2xl tw-font-normal"
            >{{ monthName }}</span
          >

          <!-- loading -->
          @if(isLoading){
          <div class="tw-px-4">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
          } @if(getCalenderDataFromServer){
          <app-field-searcher
            type="singleEnumSelect"
            enumName="PersianMonth"
            [hasSelectAll]="false"
            [noNumberSeparator]="true"
            [hasMatToolTip]="false"
            (comparisonItem)="getComparisonItem($event)"
          >
          </app-field-searcher>
          } @else{
          <select
            [(ngModel)]="month"
            (change)="onChangeMonth($event)"
            class="small-select tw-text-2xl tw-outline-none text-center tw-border-0 tw-w-[70px] tw-h-[30px]"
          >
            <option
              class="tw-text-gray-500 dark:tw-text-gray-300 text-center"
              *ngFor="let item of displayableMonths"
              [value]="item.key"
            >
              <span class="tw-p-2"> {{ item.value }}</span>
            </option>
          </select>

          }
        </div>

        <!-- year -->
        <span
          class="tw-px-4 tw-text-2xl tw-font-normal"
          [class.tw-cursor-pointer]="getCalenderDataFromServer"
          (click)="onShowYearsModal(year)"
          >{{ year }}</span
        >
      </div>

      <!-- next Month -->
      <div
        class="tw-flex tw-items-center tw-text-white"
        (click)="nextMonth()"
        [class]="disableNextMonthBtn ? 'tw-opacity-60' : 'tw-cursor-pointer'"
      >
        <span class="tw-text-lg">{{ "common.nextMonth" | translate }}</span>
        <i
          class="mdi mdi-chevron-left mdi-22px tw-text-white dark:tw-text-gray-400"
        ></i>
      </div>
    </div>

    <!-- Days of the Week -->
    <div class="tw-grid tw-grid-cols-7 tw-gap-2 tw-my-5 tw-pt-3">
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.saturday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.sunday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.monday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.tuesday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.wednesday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.thursday" | translate
      }}</span>
      <span class="tw-text-primary-700 dark:tw-text-primary-300 sm:tw-text-lg tw-text-sm tw-font-bold">{{
        "common.daysOfTheWeek.friday" | translate
      }}</span>
    </div>

    <!-- get calender items -->
    <div *ngIf="!isLoading" class="tw-grid tw-grid-cols-7 tw-gap-2">
      <div
        *ngFor="
          let item of getRange(
            (items | calenderFilterDaysByMonth : month)?.[0]?.daysOfWeek
          )
        "
      ></div>
      <div
        class="tw-h-20"
        *ngFor="
          let item of items | calenderFilterDaysByMonth : month;
          let i = index
        "
        [class]="
          item?.id == selectedId && !item.selected
            ? ' tw-border-2 tw-rounded-2xl tw-border-primary-200 dark:tw-border-primary-700'
            : ''
        "
      >
        <app-calendar-card
          [class.tw-opacity-30]="item.disabled"
          [showEventCircle]="getCalenderDataFromServer"
          [model]="item"
          [selected]="item.selected"
          [todayDate]="todayDate"
          (click)="toggleSelectDay(item)"
          (selectedDay)="onChangeSelectedDay($event)"
        ></app-calendar-card>
      </div>
    </div>

    <!-- pre loading -->
    <div *ngIf="isLoading" class="tw-grid tw-grid-cols-7 tw-gap-2">
      <div *ngFor="let item of getRange(31)">
        <div class="bg-preloading tw-w-full tw-rounded-2xl tw-h-[65px]"></div>
      </div>
    </div>
  </div>
</div>
